import React from "react";
import { Button, Link, Message, Modal, Typography } from "@arco-design/web-react";

const { Title, Text } = Typography;

// Merge-tag picker. Each tag matches a field the backend exposes to templates as
// {{ .Contact.* }} (see mail_api expand's ContactVars). Clicking a tag copies it
// to the clipboard so it can be pasted into the subject or body — robust across
// the visual and source editors (no fragile editor-text injection).
const MERGE_TAGS = [
    { name: "Name", template: "{{ .Contact.Name }}" },
    { name: "Email", template: "{{ .Contact.Email }}" },
    { name: "City", template: "{{ .Contact.City }}" },
    { name: "State", template: "{{ .Contact.State }}" },
    { name: "Country", template: "{{ .Contact.Country }}" },
];

export function PersonalizationDialog({ render }) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const copyTag = (tag) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(tag.template).then(
                () => Message.success(`Copied ${tag.template} — paste it into your subject or body`),
                () => Message.error("Couldn't copy to clipboard")
            );
        } else {
            Message.info(`Copy this tag: ${tag.template}`);
        }
    };

    return (
        <>
            {render(handleClickOpen)}
            <Modal
                visible={open}
                onCancel={handleClose}
                title="Personalize Email"
                footer={
                    <Button onClick={handleClose} type="text">
                        Close
                    </Button>
                }
            >
                <Title heading={6}>Click a tag to copy it, then paste into your subject or body</Title>
                {MERGE_TAGS.map((tag) => (
                    <div key={tag.template} style={{ marginBottom: 8 }}>
                        <Link style={{ cursor: "pointer" }} onClick={() => copyTag(tag)}>
                            {tag.name}
                        </Link>{" "}
                        <Text type="secondary" style={{ fontSize: 12 }}>{tag.template}</Text>
                    </div>
                ))}
            </Modal>
        </>
    );
}
